export default __webpack_public_path__ + "static/media/star.7fee9720.png";